module.exports = __webpack_public_path__ + "static/media/global_card1.546b6875.svg";